import { Helmet } from 'react-helmet';
import { withTheme } from '@emotion/react';
import styled from '@emotion/styled';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import BasicTextBlock from '../../components/shared/BasicTextBlock';
import SearchForm from '../../components/SearchForm/';
import InfoCTA from '../../components/InfoCTA';
import LogoBlock from '../../components/LogoBlock';
import BlockCTA from '../../components/BlockCTA';

import { 
  textBlockData,
  logosData,
  infoCTAData,
  blockCTAData,
  textBlockData2,
  SEOData
} from './data';

const ContentContainer = styled.div`
  align-items: center;
  background-color: ${props => props.bgColor ? props.bgColor : props.theme.colors.constrast2};
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
  justify-content: center;
  overflow-x: hidden;
  margin-top: ${props => props.marginTop || '0px'};
  padding: ${props => props.paddingValues || props.theme.margins.std};
`;

function Home(props) {
  const { title, description, keywords } = SEOData;
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
      </Helmet>
      <Navigation />
      <ContentContainer marginTop="54px">
        <SearchForm />
      </ContentContainer>
      <ContentContainer bgColor={props.theme.colors.neutral2}>
        <BasicTextBlock textColor="primary4" textBlockData={textBlockData} />
      </ContentContainer>
      <ContentContainer>
        <LogoBlock data={logosData} />
        <InfoCTA data={infoCTAData} />
      </ContentContainer>
      <ContentContainer bgColor={props.theme.colors.primary3}>
        <BasicTextBlock textColor="contrast2" headerColor="contrast2" textBlockData={textBlockData2} />
      </ContentContainer>
      <ContentContainer paddingValues={`${props.theme.margins.std} 0px`}>
        <BlockCTA data={blockCTAData} />
      </ContentContainer>
      <Footer />
    </>
  );
}

export default withTheme(Home);